import React, {useContext, useEffect, useState} from 'react';
import {LoadPagePanel} from '../../../../components';
import {showErrorMessage, showSuccessMessage} from '../../../../utils/messages';
import {useGetFiles} from '../../../common/file-attachments/api/get-file-attachments';
import {RetailOrderContext} from '../../retail-order/context/RetailOrderContext';
import {useGetNewMaterialOrder} from '../api/get-new-material-order';
import {apiGetNewMaterialOrderProducts} from '../api/get-new-material-order-products';
import {MaterialOrderContext, RefetchScope} from '../context/MaterialOrderContext';
import {calculateTotals} from '../functions/calculateTotals';
import {MaterialOrderContextType} from '../types/MaterialOrderContextType';

export default function NewMaterialOrderPage(props: React.PropsWithChildren<unknown>) {

	const { order: retailOrder } = useContext(RetailOrderContext);
	const [orderState, setOrderState] = useState<MaterialOrderContextType>({} as MaterialOrderContextType);
	const { data: moData, isLoading } = useGetNewMaterialOrder(retailOrder.details?.retailOrderID);

	const { refetch: refetchFiles, isRefetching: isFilesRefetching } =
		useGetFiles(orderState.details?.guid, false);

	useEffect(() => {
		if (moData) {
			if (moData.products) {
				var totals = calculateTotals(moData.products, moData.taxRate);
				moData.subTotal = totals.subTotal;
				moData.freightCharges = totals.freightCharges;
				moData.cutCharges = totals.cutCharges;
				moData.salesTax = totals.salesTax;
				moData.taxAmount = totals.taxAmount;
				moData.amount = totals.total;
			}
			setOrderState({ details: moData });
		}
	}, [moData]);

	useEffect(() => {
		if (orderState.pricingNeedsUpdate) {

			if (!orderState.details.products || orderState.details.products.length === 0) {
				setOrderState({
					...orderState,
					pricingNeedsUpdate: false
				});

				return;
			}

			apiGetNewMaterialOrderProducts(
				orderState.details.shipToLocationID,
				orderState.details.salesChannelID,
				orderState.details.roDate,
				orderState.details.products.map((x) => {
					return {
						...x,
						searchAdhesive: false
					}
				}))
				.then((result) => {

					if (result.isSuccess) {

						if (orderState.repricingButtonClicked) {
							showSuccessMessage("Prices have been updated");
						}

						const totals = calculateTotals(result.products, orderState.details.taxRate);
						setOrderState({
							details: {
								...orderState.details,
								subTotal: totals.subTotal,
								amount: totals.total,
								freightCharges: totals.freightCharges,
								cutCharges: totals.cutCharges,
								salesTax: totals.salesTax,
								taxAmount: totals.taxAmount,
								products: result.products,
								productMFRSKUs: result.productMFRSKUs
							},
							pricingNeedsUpdate: false,
							repricingButtonClicked: false
						});
					}
					else {
						if (result.errorMessage) {
							showErrorMessage(result.errorMessage);
						}

						setOrderState({
							...orderState,
							pricingNeedsUpdate: false,
							repricingButtonClicked: false
						});
					}
				})
		}
	}, [orderState.details?.products, orderState.pricingNeedsUpdate]);

	return (
		<React.Fragment>
			{
				orderState.details &&
				<MaterialOrderContext.Provider value={{
					order: orderState,
					modifyOrder: (details, pricingNeedsUpdate, repricingButtonClicked) => setOrderState({
						details: details,
						pricingNeedsUpdate: pricingNeedsUpdate,
						repricingButtonClicked: repricingButtonClicked
					}),
					refetchOrder: (scope?: RefetchScope) => {
						return new Promise(() => {
							if (scope === RefetchScope.Files) {
								refetchFiles()
									.then((result) => {
										if (result.data) {
											setOrderState({ ...orderState, details: { ...orderState.details, files: result.data! } });
										}
									});
							}
						});
					}
				}}>

					{props.children}

				</MaterialOrderContext.Provider>
			}

			<LoadPagePanel visible={isLoading || isFilesRefetching} />

		</React.Fragment>)
}
